import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import * as fromRouter from '@ngrx/router-store';

import { environment } from '@env';

export interface State {
    router: fromRouter.RouterReducerState<any>;
}

export const reducers: ActionReducerMap<State> = {
    router: fromRouter.routerReducer
};

export const metaReducers: MetaReducer<State>[] = !environment.production ? [] : [];
